import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";
import BMXSelectField from "../../../../../Components/Inputs/BMXSelectField/BMXSelectField";
import BMXTextField from "../../../../../Components/Inputs/BMXTextField/BMXTextField";
import BMXSeparator from "../../../../../Components/Separator/BMXSeparator";
import { GlobalAuthFetch } from "../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";


const CrmFormStepDescription = (props) => {
  const { t } = useTranslation();

  const [acquisitionSourceSelect, setAcquisitionSourceSelect] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const acquisitionSourceFetch = GlobalAuthFetch({
        path: "/dictionary/acquisitionSource/fieldName",
      });

      const [acquisitionSourcePayload] = await Promise.all([
        acquisitionSourceFetch,
      ]);

      setAcquisitionSourceSelect(
        acquisitionSourcePayload?.payload?.data?.dictionaryEntries
      );
    };
    fetchData();
  }, []);

  return (
    <div
      className="CrmFormStepDescription"
      style={{ justifyContent: "flex-start" }}
    >
      <BMXSeparator title={t("global:crm.descriptionInformation")} />
      <Row>
        <Col xs={12}>
          <Field
            component={BMXTextField}
            label={`${t("global:crm.threat")}`}
            name="threat"
            data-cy="threat"
          />
        </Col>

        <Col xs={12}>
          <Field
            component={BMXSelectField}
            values={acquisitionSourceSelect?.map((el) => ({
              name: el.entryName,
              value: el.uuid,
            }))}
            label={`${t("global:crm.acquisitionSource")}`}
            name="acquisitionSource"
            data-cy="acquisitionSource"
          />
        </Col>
        <Col xs={12}>
          <Field
            component={BMXTextField}
            label={`${t("global:crm.finalGrade")}`}
            name="finalGrade"
            data-cy="finalGrade"
          />
        </Col>
      </Row>
    </div>
  );
};

export default CrmFormStepDescription;
